import { httpApi } from "./http.api";
const priceListsCacheMap: Map<string, Promise<any>> = new Map();

export const getRolesData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/job/?all=True").then((data: any) => data.data);

export const getTalentPoolRolesData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/job/?all=True&is_talent_pool=True").then((data: any) => data.data);

export const getMyRoleData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/job/?my-jobs=True").then((data: any) => data.data);

export const getRolesDataPagination = (
  pageNumber: any,
  orderings: any = ""
): Promise<{
  count: number;
  next: string;
  previous: string | undefined;
  results: any[];
}> =>
  httpApi
    .get<{
      count: number;
      next: string;
      previous: string | undefined;
      results: any[];
    }>("hiring/job/?page=" + pageNumber + "&ordering=" + orderings)
    .then((data: any) => data.data);

export const getDEIStat = (id: any): Promise<any[]> =>
  httpApi.get<any[]>(`hiring/job-stats/${id}/`).then((data: any) => data.data);

export const deleteRole = async (id: number): Promise<any> => {
  return httpApi.delete<any>(`hiring/job/${id}/`, {});
};

export const addCandidateToRole = (pipelinePayload: any): Promise<any> => {
  if (!pipelinePayload.search_id) {
    delete pipelinePayload.search_id;
  }

  return httpApi
    .post<any>("hiring/custom-assignment/add-candidate-to-job/", {
      ...pipelinePayload,
    })
    .then(({ data }) => data);
};

export const addRole = (rolePayload: any): Promise<any> =>
  httpApi.post<any>("hiring/job/", rolePayload).then(({ data }) => data);

export const updateRole = (roleId: any, rolePayload: any): Promise<any> =>
  httpApi
    .patch<any>("hiring/job/" + roleId + "/", rolePayload)
    .then(({ data }) => data);

export const getRole = (id: any, hardRefresh = false): Promise<any> | any => {
  if (hardRefresh || !priceListsCacheMap.has(id)) {
    const jobDetails = httpApi
      .get<any[]>("hiring/job/" + id)
      .then((data: any) => data.data);
    priceListsCacheMap.set(id, jobDetails);
    return jobDetails;
  }
  return priceListsCacheMap.get(id);
};

export const importCandidateToRole = (candidateUrl: any): Promise<any> =>
  httpApi
    .post<any>("hiring/custom-assignment/import-candidate-to-job/", {
      ...candidateUrl,
    })
    .then(({ data }) => data);

export const deleteRoles = (jobIds: any): Promise<any> =>
  httpApi
    .post<any>("hiring/delete-jobs/", {
      jobs: jobIds ? jobIds : [],
    })
    .then(({ data }) => data);

export const rejectCandidateFromJob = (payload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/reject-candidate/reject-candidate-for-job/", {
      candidates: [...payload.candidates],
      jobs: [...payload.jobs],
      is_rejected: true,
    })
    .then(({ data }) => data);

export const getSuggestedCandidate = (
  id: any,
  page: number
): Promise<any> =>
  httpApi
    .get<any>("hiring/suggested-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getShortListedCandidate = (
  id: any,
  page: number
): Promise<any> =>
  httpApi
    .get<any>("hiring/shortlisted-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getImportedCandidate = (id: any, page: number): Promise<any> =>
  httpApi
    .get<any>("hiring/imported-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getRejectedCandidates = (
  id: any,
  page: number
): Promise<any> =>
  httpApi
    .get<any>("hiring/rejected-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getSearchesOfJob = (id: any, page: any = 1): Promise<any> =>
  httpApi
    .get<any>("hiring/searches-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const downLoadShortListCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/shortlisted-candidates/" + id + "/")
    .then(({ data }) => data);

export const downLoadImportCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/imported-candidates/" + id + "/")
    .then(({ data }) => data);

export const downloadRejectedCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/rejected-candidates/" + id + "/")
    .then(({ data }) => data);

export const downloadSuggestedCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/suggested-candidates/" + id + "/")
    .then(({ data }) => data);

//{{base_url}}/hiring/export-candidates-for-job/export-candidates/
/**
 * 
 * {
    "job_id": 1344,
    "candidate_ids": [],
    "candidate_type": "shortlisted-candidates"
}
 */
export const exportCandidates = (payload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/export-candidates-for-job/export-candidates/", payload)
    .then(({ data }) => data);

export const exportCandidatesPipeline = (payload: any): Promise<any> =>
  httpApi
    .post<any>(
      "hiring/export-candidates-for-pipeline/export-candidates/",
      payload
    )
    .then(({ data }) => data);

export const initiateBulkEmail = (payload: any): Promise<any> =>
  httpApi
    .post<any>("bulkemail/bulk-email/initiate-bulk-email/", payload)
    .then(({ data }) => data);

export const getBulkEmailStatus = (id: any): Promise<any> =>
  httpApi
    .get<any>("bulkemail/bulk-email-data/?bulk_email_id=" + id)
    .then(({ data }) => data);

//{{base_url}}/hiring/custom-assignment/bulk-import-candidates-to-job/
export const bulkImportUrls = (roleId: any, rolePayload: any): Promise<any> =>
  httpApi
    .post<any>(
      "hiring/custom-assignment/bulk-import-candidates-to-job/",
      rolePayload
    )
    .then(({ data }) => data);

// Create get_contributors function having query param job_id
export const getContributors = (
  jobId: any = 0,
  pipelineId: any = 0,
  page: number
): Promise<any> => {
  const searchString =
    "?" +
    (jobId ? "job_id=" + jobId : pipelineId ? "pipeline_id=" + pipelineId : "");
  if (pipelineId) {
    return httpApi
      .get<any>("hiring/share-pipeline/get-contributors/" + searchString)
      .then(({ data }) => data);
  }

  return httpApi
    .get<any>("hiring/share-job/get-contributors/" + searchString)
    .then(({ data }) => data);
};

export const addContributors = (
  jobIds: any,
  contributor_ids: any,
  pipelineId: any = 0
): Promise<any> => {
  if (pipelineId) {
    return httpApi
      .post<any>("hiring/share-pipeline/add-contributors/", {
        pipeline_ids: pipelineId,
        contributor_ids: contributor_ids,
      })
      .then(({ data }) => data);
  }

  return httpApi
    .post<any>("hiring/share-job/add-contributors/", {
      job_ids: jobIds,
      contributor_ids: contributor_ids,
    })
    .then(({ data }) => data);
};

export const removeContributor = (
  jobId: any,
  contributor_ids: any,
  pipelineId: any = 0
): Promise<any> => {
  if (pipelineId) {
    return httpApi
      .post<any>("hiring/share-pipeline/delete-contributors/", {
        pipeline_ids: pipelineId,
        contributor_ids: contributor_ids,
      })
      .then(({ data }) => data);
  }

  return httpApi
    .post<any>("hiring/share-job/delete-contributors/", {
      job_ids: jobId,
      contributor_ids: contributor_ids,
    })
    .then(({ data }) => data);
};

//{{beta_url}}/hiring/share-job/get-all-team-members/
export const getAllTeamMembers = (jobId = 0, pipelineId = 0): Promise<any> => {
  const searchString =
    "?" +
    (jobId ? "job_id=" + jobId : pipelineId ? "pipeline_id=" + pipelineId : "");

  if (pipelineId) {
    return httpApi
      .get<any>("hiring/share-pipeline/get-all-team-members/" + searchString)
      .then(({ data }) => data);
  }
  return httpApi
    .get<any>("hiring/share-job/get-all-team-members/" + searchString)
    .then(({ data }) => data);
};
